// extracted by mini-css-extract-plugin
export default {"section":"Skills_section__YKqRw","container":"Skills_container__5+yxw","tech":"Skills_tech__IdPYM"};